﻿import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { authApi } from '../../api/services';
import toast from 'react-hot-toast';
export default function OtpPage() {
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const phone = (location.state as any)?.phone || '';
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault(); setLoading(true);
    try {
      await authApi.verifyOtp({ phone, code });
      toast.success('Doğrulama başarılı!');
      navigate('/login');
    } catch (err: any) { toast.error(err.response?.data?.error || 'Doğrulama başarısız'); }
    finally { setLoading(false); }
  };
  return (
    <div style={{minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',padding:'24px'}}>
      <div className='card' style={{width:'100%',maxWidth:'380px',padding:'40px'}}>
        <h1 style={{textAlign:'center',marginBottom:'8px'}}>📱 OTP Doğrulama</h1>
        <p className='text-muted text-center' style={{marginBottom:'32px'}}>{phone} numarasına gönderilen kodu girin</p>
        <form onSubmit={handleSubmit} style={{display:'flex',flexDirection:'column',gap:'16px'}}>
          <div className='form-group'><label className='form-label'>6 Haneli Kod</label><input className='form-input' value={code} onChange={e=>setCode(e.target.value)} maxLength={6} placeholder='123456' style={{fontSize:'1.5rem',letterSpacing:'0.3em',textAlign:'center'}} required /></div>
          <button className='btn btn-primary btn-full btn-lg' disabled={loading}>{loading ? '...' : 'Doğrula'}</button>
        </form>
        <p className='text-center text-muted' style={{marginTop:'16px',fontSize:'0.85rem'}}>Kodu almadınız mı? <button onClick={()=>authApi.resendOtp(phone).then(()=>toast.success('Yeniden gönderildi'))} style={{background:'none',border:'none',color:'var(--color-primary)',cursor:'pointer'}}>Tekrar Gönder</button></p>
      </div>
    </div>
  );
}
